// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProjectsRoute: ProjectsRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,ServicesSlugRoute: ServicesSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)